import { ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { scrollToId } from "@/lib/scroll";

export const AboutPreview = () => (
  <section id="about" className="relative py-12 sm:py-16">
    <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-14 px-5 sm:px-8 lg:grid-cols-2">
      <Reveal>
        <Eyebrow>About Viral Pulse</Eyebrow>
        <h2 className="mt-6 font-display text-4xl font-extrabold leading-[0.95] tracking-tighter text-white sm:text-5xl lg:text-6xl">
          Marketing Has Changed.{" "}
          <span className="text-purple-500">Experience Still Matters.</span>
        </h2>
        <p className="mt-7 max-w-xl text-base leading-relaxed text-zinc-400 md:text-lg">
          Viral Pulse combines years of digital marketing experience with today's
          advertising platforms, creators, content and internet culture.
        </p>
        <p className="mt-5 max-w-xl text-base leading-relaxed text-zinc-400 md:text-lg">
          We understand both sides: how to get attention — and how to turn that
          attention into business.
        </p>
        <button
          type="button"
          data-testid="meet-viral-pulse-cta"
          onClick={() => scrollToId("contact")}
          className="group mt-9 flex items-center gap-2.5 rounded-full border border-white/15 bg-white/5 px-8 py-4 text-sm font-bold uppercase tracking-wide text-white transition-colors duration-300 hover:border-purple-500/60 hover:bg-purple-600"
        >
          Meet Viral Pulse
          <ArrowUpRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
        </button>
      </Reveal>

      <Reveal delay={0.15}>
        {/* PHOTO SLOT: replace this panel with a real founder/team photo when provided.
            Recommended: <img src="/assets/team.jpg" alt="The Viral Pulse team" className="rounded-3xl" />
            Do NOT use generated or stock headshots. */}
        <div
          data-testid="about-visual"
          className="flex min-h-[380px] flex-col justify-end rounded-3xl border border-[#272732] bg-[#121217] p-10"
        >
          <p className="font-display text-3xl font-extrabold leading-tight tracking-tight text-white sm:text-4xl">
            Attention is easy to get.
            <span className="mt-2 block text-purple-500">Turning it into business is the skill.</span>
          </p>
          <div className="mt-8 h-px w-full bg-white/10" />
          <p className="mt-5 text-sm font-bold uppercase tracking-[0.2em] text-zinc-500">
            Las Vegas Based • Campaigns Nationwide
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);
